import React, { useEffect, useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "react-router-dom";
import coursCss from "./Courses.module.css";
import course1 from "../../asset/Image/course1.jpg";
import course2 from "../../asset/Image/course2.jpg";
import course3 from "../../asset/Image/course3.jpg";
import course4 from "../../asset/Image/course4.jpg";
import RestClient from "../../RestApi/RestClient";
import AppUrl from "../../RestApi/AppUrl";
import LightSpeed from "react-reveal/LightSpeed";
import Fade from "react-reveal/Fade";
export default function Courses() {
  const [courses, setCourses] = useState([]);
  useEffect(() => {
    RestClient.GetRequest(AppUrl.HomeCourse).then((result) =>
      setCourses(result)
    );
  }, []);
  return (
    <>
      <Container className="my-5">
        <Fade top>
          <h1 className="serviceMainTitle text-center">Popular Courses</h1>
        </Fade>
        <div className={`${coursCss.bottom}`}></div>
        <Row>
          {courses.map((course, i) => {
            return (
              <Col lg={6} md={12} sm={12} key={i}>
                <Row className="mb-5">
                  <Col lg={6} md={12} sm={12}>
                    <LightSpeed left>
                      <img
                        src={course.course_image}
                        alt=""
                        className="img-fluid"
                      />
                    </LightSpeed>
                  </Col>
                  <Col lg={6} md={12} sm={12}>
                    <LightSpeed right>
                      <h5 className={`${coursCss.title} text-justify`}>
                        {course.short_title}
                      </h5>
                      <h5 className={`${coursCss.description} text-justify`}>
                        {course.short_description}
                      </h5>
                      <Link
                        to={`/courseDetails/${course.id}/${course.short_title}`}
                        className={`${coursCss.button} text-justify`}
                      >
                        View details
                      </Link>
                    </LightSpeed>
                  </Col>
                </Row>
              </Col>
            );
          })}
        </Row>
      </Container>
    </>
  );
}
